"use client"

import SpinnerWrapper from "@/components/common/spinner/spinnerWrapper"

import type { ReactNode } from "react"

const MyApp = ({ children }: { children?: ReactNode }) => {
  return <SpinnerWrapper>{children}</SpinnerWrapper>
}

export default MyApp
